<div class="title-container">
    <!--<mat-icon fontSet="phr-iconset" [ngClass]="getProfileTypeIconClassName()"></mat-icon>-->
    {{texto1}} {{(texto2 ? 'de ' + texto2 : '')}} {{texto3 ? textoPrep + ' ' + texto3 : ''}}
</div>